import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { isIOSApp } from 'utils';
import brand from 'shared/app/model/branding';
import { isH2000Device } from 'entities/billing.h2000-firmware/lib/is-h2000';
const haveH2000Device = createSelector(selectDevicesFields(['device_type', 'hardware_type']), (devices) => devices.some(isH2000Device));
export const useShowBuyH2000Firmware = () => {
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const have_device = useAppSelector(haveH2000Device);
    return (brand.enable_paid_options.h2000plus_firmware &&
        !is_demo &&
        !isIOSApp() &&
        have_device);
};
